import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Career } from './pages/Career';
import { Career2 } from './pages/Career2';
import { Career3 } from './pages/Career3';
import { CareerLanding } from './pages/CareerLanding';
import { Courses } from './pages/Courses';
import { Course } from './pages/Course';
import { Lesson } from './pages/Lesson';
import { Module } from './pages/Module';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { Dashboard } from './pages/Dashboard';
import { Profile } from './pages/Profile';
import { Support } from './pages/Support';
import { CommissionCalculator } from './pages/CommissionCalculator';
import { Onboarding } from './pages/Onboarding';
import { OnboardingSuccess } from './pages/OnboardingSuccess';
import { Rental } from './pages/Rental';
import { RentalModuleLocked } from './pages/RentalModuleLocked';
import { SaleModuleLocked } from './pages/SaleModuleLocked';
import { ProspectingLists } from './pages/rental/ProspectingLists';
import { ProspectingListsKanban } from './pages/rental/ProspectingListsKanban';
import { CreateListing } from './pages/rental/CreateListing';
import { Listings } from './pages/rental/Listings';
import { ListingDetail } from './pages/rental/ListingDetail';
import { ListingPreview } from './pages/rental/ListingPreview';
import { RentalLeads } from './pages/rental/RentalLeads';
import { Viewings } from './pages/rental/Viewings';
import { ViewingsTutorial } from './pages/rental/ViewingsTutorial';
import { LeadsTutorial } from './pages/rental/LeadsTutorial';
import { ProspectingTutorial } from './pages/rental/ProspectingTutorial';
import { Contracts } from './pages/rental/Contracts';
import { CreateContract } from './pages/rental/CreateContract';
import { Transactions } from './pages/Transactions';
import { DepositPayment } from './pages/DepositPayment';
import { RentalLayout } from './components/rental/RentalLayout';
import { PropertyPresentation } from './pages/rental/PropertyPresentation';
import { PropertyPresentationView } from './pages/rental/PropertyPresentationView';
function PrivateRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    loading
  } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div data-id="element-6">Loading...</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{
      from: location
    }} replace data-id="element-7" />;
  }
  return <>{children}</>;
}
export function AppRouter() {
  return <div className="flex flex-col min-h-screen" data-id="element-8">
      <Navbar data-id="element-9" />
      <main className="flex-grow" data-id="element-10">
        <Routes data-id="element-11">
          {/* Public Routes */}
          <Route path="/" element={<Navigate to="/cariera-3" replace data-id="element-13" />} data-id="element-12" />
          <Route path="/despre" element={<About data-id="element-15" />} data-id="element-14" />
          <Route path="/cariera-imobiliare" element={<CareerLanding data-id="element-17" />} data-id="element-16" />
          <Route path="/cariera-old" element={<Career data-id="element-19" />} data-id="element-18" />
          <Route path="/cariera-2" element={<Career2 data-id="element-21" />} data-id="element-20" />
          <Route path="/cariera-3" element={<Career3 data-id="element-23" />} data-id="element-22" />
          <Route path="/cursuri" element={<Courses data-id="element-25" />} data-id="element-24" />
          <Route path="/auth/login" element={<Login data-id="element-27" />} data-id="element-26" />
          <Route path="/auth/register" element={<Register data-id="element-29" />} data-id="element-28" />
          <Route path="/calculator" element={<CommissionCalculator data-id="element-31" />} data-id="element-30" />
          <Route path="/support" element={<Support data-id="element-33" />} data-id="element-32" />

          {/* Protected Routes */}
          <Route path="/dashboard" element={<PrivateRoute data-id="element-35">
                <Dashboard data-id="element-36" />
              </PrivateRoute>} data-id="element-34" />
          <Route path="/modul-inchiriere" element={<PrivateRoute data-id="element-38">
                <RentalModuleLocked data-id="element-39" />
              </PrivateRoute>} data-id="element-37" />
          <Route path="/modul-vanzare" element={<PrivateRoute data-id="element-41">
                <SaleModuleLocked data-id="element-42" />
              </PrivateRoute>} data-id="element-40" />
          <Route path="/profile" element={<PrivateRoute data-id="element-44">
                <Profile data-id="element-45" />
              </PrivateRoute>} data-id="element-43" />
          <Route path="/onboarding" element={<PrivateRoute data-id="element-47">
                <Onboarding data-id="element-48" />
              </PrivateRoute>} data-id="element-46" />
          <Route path="/onboarding/success" element={<PrivateRoute data-id="element-50">
                <OnboardingSuccess data-id="element-51" />
              </PrivateRoute>} data-id="element-49" />
          <Route path="/curs/:courseId" element={<PrivateRoute data-id="element-53">
                <Course data-id="element-54" />
              </PrivateRoute>} data-id="element-52" />
          <Route path="/curs/:courseId/modul/:moduleId" element={<PrivateRoute data-id="element-56">
                <Module data-id="element-57" />
              </PrivateRoute>} data-id="element-55" />
          <Route path="/curs/:courseId/modul/:moduleId/lectie/:lessonId" element={<PrivateRoute data-id="element-59">
                <Lesson data-id="element-60" />
              </PrivateRoute>} data-id="element-58" />
          <Route path="/tranzactii" element={<PrivateRoute data-id="element-62">
                <Transactions data-id="element-63" />
              </PrivateRoute>} data-id="element-61" />
          <Route path="/plata-garantie" element={<PrivateRoute data-id="element-65">
                <DepositPayment data-id="element-66" />
              </PrivateRoute>} data-id="element-64" />

          {/* Rental Module Routes */}
          <Route path="/inchiriere" element={<PrivateRoute data-id="element-68">
                <RentalLayout data-id="element-69" />
              </PrivateRoute>} data-id="element-67">
            <Route index element={<Rental data-id="element-71" />} data-id="element-70" />
            <Route path="liste-prospectare" element={<ProspectingLists data-id="element-73" />} data-id="element-72" />
            <Route path="liste-prospectare/tutorial" element={<ProspectingTutorial data-id="element-75" />} data-id="element-74" />
            <Route path="liste-prospectare-kanban" element={<ProspectingListsKanban data-id="element-77" />} data-id="element-76" />
            <Route path="creare-anunt" element={<CreateListing data-id="element-79" />} data-id="element-78" />
            <Route path="anunturi" element={<Listings data-id="element-81" />} data-id="element-80" />
            <Route path="anunturi/:id" element={<ListingDetail data-id="element-83" />} data-id="element-82" />
            <Route path="anunturi/:id/preview" element={<ListingPreview data-id="element-85" />} data-id="element-84" />
            <Route path="leaduri" element={<RentalLeads data-id="element-87" />} data-id="element-86" />
            <Route path="leaduri/tutorial" element={<LeadsTutorial data-id="element-89" />} data-id="element-88" />
            <Route path="vizionari" element={<Viewings data-id="element-91" />} data-id="element-90" />
            <Route path="vizionari/tutorial" element={<ViewingsTutorial data-id="element-93" />} data-id="element-92" />
            <Route path="contracte" element={<Contracts data-id="element-95" />} data-id="element-94" />
            <Route path="contracte/nou" element={<CreateContract data-id="element-97" />} data-id="element-96" />
            <Route path="ajutor" element={<Support data-id="element-99" />} data-id="element-98" />
            <Route path="prezentare-proprietate" element={<PropertyPresentation data-id="element-101" />} data-id="element-100" />
          </Route>

          {/* Public Presentation View Route */}
          <Route path="/prezentare/:presentationId" element={<PropertyPresentationView data-id="element-103" />} data-id="element-102" />
        </Routes>
      </main>
      <Footer data-id="element-104" />
    </div>;
}